import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { AccompagnementChampsType } from '../../store/participant-action-accompagnement.model';

@Component({
  selector: 'app-participant-action-accompagnement-champs',
  templateUrl: './participant-action-accompagnement-champs.component.html',
  styleUrls: ['./participant-action-accompagnement-champs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantActionAccompagnementChampsComponent
  implements OnInit, OnChanges
{
  @Input() champs: AccompagnementChampsType = { code: '', libelle: '' };

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}
}
